import _OneSignal from 'react-onesignal'

// Resolves once the SDK has established an anonymous session (onesignalId set),
// which means the internal user model (Qe) is ready and login() can be called.
let _sdkReadyPromise: Promise<void> | null = null

const waitForSdkReady = (): Promise<void> => {
  if (_sdkReadyPromise) return _sdkReadyPromise
  _sdkReadyPromise = new Promise<void>((resolve) => {
    const check = () => {
      if ((window as any).OneSignal?.User?.onesignalId) {
        resolve()
      } else {
        setTimeout(check, 500)
      }
    }
    check()
    setTimeout(resolve, 15_000) // give up after 15s (e.g. localhost)
  })
  return _sdkReadyPromise
}

export const OneSignal = {
  ..._OneSignal,
  initialize: (appIdOrConfig: string | { appId: string; [key: string]: any }) => {
    const config =
      typeof appIdOrConfig === 'string'
        ? { appId: appIdOrConfig, serviceWorkerPath: '/OneSignalSDKWorker.js' }
        : { serviceWorkerPath: '/OneSignalSDKWorker.js', ...appIdOrConfig }
    const initPromise = _OneSignal.init(config)
    waitForSdkReady() // start polling in the background
    return initPromise
  },
  login: async (externalId: string, jwtToken?: string) => {
    await waitForSdkReady()
    return _OneSignal.login(externalId, jwtToken)
  },
  Notifications: {
    ..._OneSignal.Notifications,
    getPermissionAsync: async () => {
      return Promise.resolve(_OneSignal.Notifications.permission)
    }
  },
  User: {
    ..._OneSignal,
    pushSubscription: _OneSignal.User.PushSubscription
  }
}
